module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a34e9e4e9fe1e7cce45eebd2c471fb0c.png";